import * as types from './types'

export function set (payload) {
  return {
    type: types.SET,
    payload,
  }
}
